import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HeaderSearchBaseComponent } from '../../base/header-search-base/header-search-base.component';
import { DataAttributeDirective } from '@shared/directives/data-attribute.directive';
import { SearchBarComponent } from '../../../search-bar/search-bar.component';
import { BackButtonComponent } from '@shared/components/back-button/back-button.component';
import { CartFacade } from '../../../../../../store/cart';
import { UserFacade } from '../../../../../../store/user/user.facade';

@Component({
  selector: 'tiss-header-search-compact',
  imports: [DataAttributeDirective, SearchBarComponent, BackButtonComponent],
  templateUrl: './header-search-compact.component.html',
  styleUrl: './header-search-compact.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CartFacade, UserFacade],
})
export class HeaderSearchCompactComponent extends HeaderSearchBaseComponent {}
